import type { FC } from 'react'

import { TableWithFilter, useStepControllerMethods } from '../../components'
import type { OnSetFilterFormFunc, RowWellVsp } from '../../types'

type StepChooseWellWithVspProps = Record<string, never>

export const StepChooseWellWithVsp: FC<StepChooseWellWithVspProps> = () => {
  const { addNextStep, setContextToActiveStep } = useStepControllerMethods()

  const handleRowClick = (row: RowWellVsp) => {
    addNextStep(row.wellName, 'chooseVsp', row.id)
  }

  const saveContext: OnSetFilterFormFunc = form => {
    setContextToActiveStep('chooseWellWithVsp', form)
  }

  return (
    <TableWithFilter
      prompt="Выберите скважину, откуда хотите применить скоростной закон"
      saveContext={saveContext}
      hasNextStep={true}
      forceWithVsp={true}
      onRowClick={handleRowClick}
    />
  )
}
